import { createAction, props, union } from '@ngrx/store';

import { FeatureState } from '@global/infrastructure/interfaces/feature-state';
import { JourneyPath } from '@global/infrastructure/interfaces/journey-path-state';

export const loadNextJourneyDetails = createAction(
  '[JourneyNavigation] Load Next Journey Details',
  props<{ nextJourneyDetails: FeatureState }>()
);

export const buildJourneyPath = createAction(
  '[JourneyNavigation] Build Journey Path',
  props<{ journeyPath: JourneyPath }>()
);

export const setNavDirection = createAction(
  '[JourneyNavigation] Set Nav Direction',
  props<{ navDirection: number }>()
);

export const changeButtonStatus = createAction(
  '[JourneyNavigation] Change Button Status',
  props<{id: string, status: boolean}>()
);

export const changeButtonVisibility = createAction(
  '[JourneyNavigation] Change Button Visibility',
  props<{ id: string, status: boolean }>()
);

export const changeButtonLabel = createAction(
  '[JourneyNavigation] Change Button Label',
  props<{ id: string, label: string }>()
);


const all = union({
  loadNextJourneyDetails,
  buildJourneyPath,
  setNavDirection,
  changeButtonStatus,
  changeButtonVisibility,
  changeButtonLabel
});

export type JourneyNavigationActionsUnion = typeof all;
